$(document).ready(function() {
    $('.searchButtonMineTop').click(function() {
        $('.searchButtonMine').click();
    });

    $('body').on('mouseenter', '.linkListMenu.subMenuActive', function() {
        $(this).find('.linkListSubmenu').css({
            'opacity': '1',
            'visibility': 'visible',
            'transform': 'translateX(0)'
        });
    });

    $('body').on('mouseleave', '.linkListMenu.subMenuActive', function() {
        $(this).find('.linkListSubmenu').css({
            'opacity': '0',
            'visibility': 'hidden',
            'transform': 'translateX(-100%)'
        });
    });

    $('body').on('click', '.tabLink', function(){
        var tab = $(this).attr('data-tab');
        $(this).parents('.productsTab').find('.tabLink').removeClass('active');
        $(this).addClass('active');
        $(this).parents('.productsTab').find('.tabProduct').addClass('hide');
        $('.tabProduct[data-tab="'+tab+'"]').removeClass('hide');
    });
});